var render = function render(){var _vm=this,_c=_vm._self._c;return _c('table',[_c('PatientRowHead',{attrs:{"type":"success","active-columns":_vm.activeColumns}}),_c('tbody',_vm._l((_vm.patients),function(patient,index){return _c('PatientResult',{key:'result' + index,attrs:{"patient":patient,"active-columns":_vm.activeColumns}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }